"use strict";

function openModal(modalId) {
  const currentShowModal = document.querySelector(".modal.show");
  if (currentShowModal) currentShowModal.classList.remove("show");

  const modal = document.querySelector(modalId);
  if (!modal) return;
  modal.classList.add("show");
}

function handleFormTypeValue(value) {
  const advertisersForm = document.querySelector("#advertisers-form");
  const publishersForm = document.querySelector("#publishers-form");
  switch (value) {
    case "advertisers":
      advertisersForm.classList.remove("hide");
      publishersForm.classList.add("hide");
      break;
    case "publishers":
      publishersForm.classList.remove("hide");
      advertisersForm.classList.add("hide");
      break;

    default:
      break;
  }
}

function initSignupModal() {
  const accountTypeSelect = document.querySelector("#account-type-select");
  accountTypeSelect.addEventListener("change", function (e) {
    switch (e.target.value) {
      case "advertisers":
        window.location.hash = "#modal=signup-advertisers";
        break;
      case "publishers":
        window.location.hash = "#modal=signup-publishers";
        break;
      default:
        break;
    }
  });
}

function openModalSignUp(modalType) {
  const accountTypeSelect = document.querySelector("#account-type-select");
  const accountType = modalType.split("-")[1];

  initSignupModal();

  switch (accountType) {
    case "advertisers":
      accountTypeSelect.value = "advertisers";
      break;
    case "publishers":
      accountTypeSelect.value = "publishers";
      break;
    default:
      accountTypeSelect.value = "advertisers";
      break;
  }
  handleFormTypeValue(accountTypeSelect.value);
  openModal("#modal-signup");
}

function handleUrlModal() {
  const param = window.location.hash;

  if (!param.includes("modal=")) return;

  const modalRequest = param.split("=")[1];

  switch (modalRequest) {
    case "signin":
      openModal("#modal-signin");
      break;
    case "signup":
      openModalSignUp(modalRequest);
      break;
    case "signup-advertisers":
      openModalSignUp(modalRequest);
      break;
    case "signup-publishers":
      openModalSignUp(modalRequest);
      break;
    case "forgotpassword":
      openModal("#modal-forgotpassword");
      break;

    default:
      break;
  }
}

function initModalAction() {
  const MODALS = document.querySelectorAll(".modal");

  if (MODALS) {
    MODALS.forEach((modal) => {
      const thisModal = modal;
      const closeBtn = modal.querySelector(".modal-close");

      function closeModal() {
        thisModal.classList.remove("show");
        history.pushState(
          "",
          document.title,
          window.location.pathname + window.location.search
        );
      }
      closeBtn.addEventListener("click", closeModal);
      modal.addEventListener("click", closeModal);

      modal
        .querySelector(".modal-container")
        ?.addEventListener("click", function (e) {
          e.stopPropagation();
        });
    });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  initModalAction();
  handleUrlModal();
  window.addEventListener(
    "hashchange",
    () => {
      handleUrlModal();
    },
    false
  );
});
